export default "__VITE_ASSET__DA$6XywC__"